import gql from 'graphql-tag'

export default gql`query ycmdChatPostUnreadCountGet($room_id: ID) {
    ycmdChatPostUnreadCountGet(room_id: $room_id) {
        post_count
        room_count
    }
}`
